module.exports = __webpack_public_path__ + "img/24.e7de1250.png";